interface Props {
  color: string;
}

export function MoonIcon({ color }: Props) {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M11.38 2.019a7.5 7.5 0 1010.6 10.6C21.662 17.854 17.316 22 12.001 22 6.477 22 2 17.523 2 12c0-5.315 4.146-9.661 9.38-9.981z"
      ></path>
    </svg>
  );
}